import React from 'react';
import { useNavigate } from 'react-router-dom';

export function AdminHeader({ title, titleExtra, back, actions }) {
  const navigate = useNavigate();
  return (
    <div style={h.bar}>
      <div style={h.left}>
        {back && (
          <button style={h.back} onClick={() => navigate(back === true ? -1 : back)}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M12.5 15L7.5 10L12.5 5" stroke="#FA1C51" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        )}
        {!back && (
          <div style={h.logoWrap}>
            <img src="/favicon.png" alt="logo" style={h.logo} />
          </div>
        )}
        <span style={h.title}>{title}</span>
        {titleExtra}
      </div>
      {actions && <div style={h.right}>{actions}</div>}
    </div>
  );
}

export const PrimaryBtn = ({ children, onClick, disabled, small }) => (
  <button
    style={{ ...btn.primary, ...(small ? btn.small : {}), ...(disabled ? btn.disabled : {}) }}
    onClick={onClick}
    disabled={disabled}
  >
    {children}
  </button>
);

export const GhostBtn = ({ children, onClick, small, disabled }) => (
  <button
    style={{ ...btn.ghost, ...(small ? btn.small : {}), ...(disabled ? btn.disabled : {}) }}
    onClick={onClick}
    disabled={disabled}
  >
    {children}
  </button>
);

// 面向商家的动作统一用紫色，和主色粉、Google 蓝区分
export const MerchantBtn = ({ children, onClick, small, disabled }) => (
  <button
    style={{ ...btn.merchant, ...(small ? btn.small : {}), ...(disabled ? btn.disabled : {}) }}
    onClick={onClick}
    disabled={disabled}
  >
    {children}
  </button>
);

export const Card = ({ children, onClick, style }) => (
  <div style={{ ...card.base, ...(onClick ? card.clickable : {}), ...style }} onClick={onClick}>
    {children}
  </div>
);

export const EmptyState = ({ text }) => (
  <div style={empty.wrap}>
    <div style={empty.circle}>
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
        <path d="M7 14h14M14 7v14" stroke="#d1d5db" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    </div>
    <p style={empty.text}>{text}</p>
  </div>
);

const h = {
  bar: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    padding: '0 16px', height: 56, background: '#fff',
    borderBottom: '1px solid #f0f0f0', position: 'sticky', top: 0, zIndex: 20,
  },
  left: { display: 'flex', alignItems: 'center', gap: 8, flex: 1, minWidth: 0 },
  back: {
    background: 'none', border: 'none', cursor: 'pointer', padding: 4,
    display: 'flex', alignItems: 'center', flexShrink: 0, marginLeft: -4,
  },
  logoWrap: { flexShrink: 0 },
  logo: { width: 28, height: 28, borderRadius: 7, display: 'block' },
  title: {
    fontSize: 17, fontWeight: 700, color: '#111',
    overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
  },
  right: { display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0, marginLeft: 8 },
};

const btn = {
  primary: {
    padding: '8px 16px', background: '#FA1C51', color: '#fff',
    border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 600,
    whiteSpace: 'nowrap',
  },
  ghost: {
    padding: '8px 14px', background: '#fff', color: '#374151',
    border: '1px solid #e5e7eb', borderRadius: 8, cursor: 'pointer', fontSize: 14,
    whiteSpace: 'nowrap',
  },
  merchant: {
    padding: '8px 16px', background: '#7C3AED', color: '#fff',
    border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 600,
    whiteSpace: 'nowrap',
  },
  small: { padding: '6px 12px', fontSize: 13 },
  disabled: { opacity: 0.5, cursor: 'default' },
};

const card = {
  base: {
    background: '#fff', borderRadius: 12,
    boxShadow: '0 1px 8px rgba(0,0,0,0.06)', overflow: 'hidden',
  },
  clickable: { cursor: 'pointer' },
};

const empty = {
  wrap: { display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '60px 20px', gap: 14 },
  circle: {
    width: 60, height: 60, borderRadius: '50%', background: '#f5f5f5',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  text: { fontSize: 14, color: '#9ca3af', margin: 0 },
};
